import { useEffect } from "react";

const useBackgroundColorChange = (
    newBgColor = '#161616',
    originalBgColor = '#202020'
) => {
    // Change the background color only for a single page
    useEffect(() => {
        const updateBackgroundColors = (bgColor) => {
            const cssQuerySelectors = [
                '[class*="Home_rightPanel"]',
                '[class*="ConnectWalletHeader_outerContainer"]',
                '[class*="ConnectWalletHeader_container"]',
                '[class*="ConnectWalletHeader_userIconContainer"]'
            ];

            for (const qs of cssQuerySelectors) {
                const domElement = document.querySelector(qs);
                if (domElement) {
                    domElement.style.backgroundColor = bgColor;
                }
            }
            document.body.style.backgroundColor = bgColor;
        }
        
        updateBackgroundColors(newBgColor);
    
        // Cleanup function to restore original values
        return () => {
            updateBackgroundColors(originalBgColor);
        };
    }, []); 
};

export default useBackgroundColorChange;